var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../libs/keybindings');
var Model = require('../libs/Model');
var modal = require('../layout/components/modal');
var measurableModel = require('../measurable/models/measurable');
var serviceTaxonomy = require('../service/serviceTaxonomy');
var buttonElement = require('../components/button');
var loaders = require('../layout/components/loaders');

var Action = Object.assign(Object.create(Model), require('../../../../models/locations/Room'));
var DEFAULT_ROOM_PORT_POSITION = 'right';
var DEFAULT_ROOM_PORT_TYPE = 'output';
var DEFAULT_ROOM_PORT_DIRECTION = 'right';
var DEFAULT_ROOM_PORT_CONNECTOR = 'head';

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

Action.roomClassTree = Action.roomClassTree || prop({ categories: [] });
Action.roomClassLoading = Action.roomClassLoading || prop(false);
Action.roomClassTreeLoaded = Action.roomClassTreeLoaded || false;

function ensureRoomClassTree() {
  if (Action.roomClassTreeLoaded) return Promise.resolve(Action.roomClassTree());
  Action.roomClassLoading(true);
  return loaders.requestWithLoader({
    loader: 'main',
    url: '/api/v1/ontology/classtree?type=room',
    method: 'GET',
    background: true
  })
  .then(tree => {
    Action.roomClassTree(tree || { categories: [] });
    Action.roomClassTreeLoaded = true;
    return tree;
  })
  .catch(error => {
    console.error('Error loading room classes:', error);
    Action.roomClassTree({ categories: [] });
  })
  .finally(() => {
    Action.roomClassLoading(false);
    m.redraw();
  });
}

function addRoomOptions(childrenArray, options, level) {
  level++;
  childrenArray.forEach(child => {
    options.push(m('option', { value: child.name }, `${'-'.repeat(level)} ${child.name}`));
    if (Array.isArray(child.children) && child.children.length > 0) {
      addRoomOptions(child.children, options, level);
    }
  });
}

function buildRoomClassOptions() {
  var tree = Action.roomClassTree ? Action.roomClassTree() : { categories: [] };
  var categories = tree && tree.categories ? tree.categories : [];
  var options = [];
  var level = 0;
  categories.forEach(category => {
    options.push(m('option', { value: category.name }, `${'-'.repeat(level)} ${category.name}`));
    if (Array.isArray(category.children) && category.children.length > 0) {
      addRoomOptions(category.children, options, level);
    }
  });
  if (!options.length) {
    var fallback = Action.roomRecordClass ? Action.roomRecordClass() : 'Room';
    options.push(m('option', { value: fallback }, fallback));
  }
  return options;
}

function hydrateRoomDiagramSvgFormValue(record) {
  if (!Action.form || !Action.form.diagramSvg || !record) return;

  var currentSvg = Action.form.diagramSvg();
  if (typeof currentSvg === 'string' && currentSvg.trim().length > 0) return;

  var convertedSvg = typeof record.diagramSvgConverted === 'string' ? record.diagramSvgConverted : '';
  if (convertedSvg.trim().length > 0) {
    Action.form.diagramSvg(convertedSvg);
  }
}


Action.editDialogue = function (record, parentRecord, options) {
  if (record && record.class) {
    record['@class'] = record.class;
  }
  Model.initForm.call(Action, record)
  Action.form.parent(parentRecord['@rid'])
  hydrateRoomDiagramSvgFormValue(record);

  Action.roomRecordClass = prop((record && record['@class']) || 'Room');
  Action.originalRoomClass = Action.roomRecordClass();
  ensureRoomClassTree();

  if (record && record.geojson) {
    if (typeof record.geojson === 'object') {
      Action.form.geojson(JSON.stringify(record.geojson));
    } else {
      Action.form.geojson(record.geojson);
    }
  }

  Action.record = record ? record : undefined;
  if (record) {
    Action.portValues = Action.form.ports() ? Object.values(Action.form.ports() || {}) : [];
  } else {
    Action.portValues = [];
  }
  Action.propertiesSectionOpen = prop(true);
  Action.mapSectionOpen = prop(false);
  Action.diagramSectionOpen = prop(false);
  Action.portsSectionOpen = prop(false);
  var submit = function () {
    Action.portValues = normalizeRoomPorts(Action.portValues);
    Action.form.ports(
      Action.portValues.reduce((acc, curr, index) => {
        acc[index] = curr;
        return acc;
      }, {})
    );
    if (Action.form.diagramSvgConverted) Action.form.diagramSvgConverted('');
    return Action.save()
      .then(async response => {
        const selectedClass = Action.roomRecordClass ? Action.roomRecordClass() : Action.originalRoomClass;
        const originalClass = Action.originalRoomClass;
        const currentRid = record && record['@rid'] ? record['@rid'] : (response && response['@rid']);
        const shouldMoveClass = selectedClass && originalClass && selectedClass !== originalClass && currentRid;

        if (shouldMoveClass) {
          const moveResponse = await loaders.requestWithLoader({
            loader: 'main',
            url: `/api/v1/room/${currentRid.slice(1)}/class`,
            method: 'PUT',
            body: { class: selectedClass }
          });

          key.unbind('enter');
          modal.vm.close();

          const route = m.route.get();
          const shouldNavigate = record && record['@rid'] && route && route.indexOf(record['@rid'].slice(1)) !== -1;
          if (shouldNavigate && moveResponse && moveResponse.newRid) {
            m.route.set('/location/' + moveResponse.newRid.slice(1));
          } else {
            options && options.submitCallback ? options.submitCallback() : '';
          }
          m.redraw();
          return;
        }

        key.unbind('enter');
        options && options.submitCallback ? options.submitCallback() : '';
        modal.vm.close();
        m.redraw();
      })
  };

  var deleteRoom = function () {
    return Action.delete(Action.record)
      .then(response => {
        key.unbind('enter');
        options && options.submitCallback ? options.submitCallback() : '';
        modal.vm.close();
        m.redraw();
      })
  }

  var renderEditModal = function () {
    key.unbind('enter');
    key.setScope('modal');
    key('enter', 'modal', submit);

    modal.vm.title(Action.record ? 'Edit Room: ' : 'Add Room: ')
    modal.vm.body = Action.view,

    Action.record && options && options.delete ?
      modal.vm.buttons([
        {
          label: "Delete",
          class: "dib red mr3 ",
          func: showDeleteConfirmation
        },
        {
          label: "Save",
          class: "dib",
          func: submit
        }
      ])
      :
      modal.vm.buttons([
        {
          label: "Save",
          class: "btn-good",
          func: submit
        }
      ]);
  };

  var showDeleteConfirmation = function () {
    key.unbind('enter');

    var confirmDelete = function () {
      return deleteRoom();
    };

    key('enter', 'modal', confirmDelete);
    modal.vm.title(`Delete ${Action.record && Action.record.name ? Action.record.name : 'Room'}?`);
    modal.vm.body = function () {
      return m('div', [
        m('p', 'Are you sure you want to delete this room?')
      ]);
    };
    modal.vm.buttons([
      {
        label: "Cancel",
        class: "dib mr2 ",
        func: function () {
          renderEditModal();
          modal.vm.open();
        }
      },
      {
        label: "Delete",
        class: "dib red ",
        func: confirmDelete
      }
    ]);
    modal.vm.open();
  };

  renderEditModal();
  var modelOptions = {
    extrawidth: true
  }
  modal.vm.open(modelOptions);
}


function ensureRoomSectionState() {
  Action.propertiesSectionOpen = Action.propertiesSectionOpen || prop(true);
  Action.mapSectionOpen = Action.mapSectionOpen || prop(false);
  Action.diagramSectionOpen = Action.diagramSectionOpen || prop(false);
  Action.portsSectionOpen = Action.portsSectionOpen || prop(false);
}

function collapsibleSection({ title, isOpen, toggle, content, index }) {
  return m(`div.w-100.bw1.bb.pv2${index === 0 ? '.bt' : ''}`, [
    m('div.w-100.flex.justify-between.items-center', { onclick: toggle }, [
      m('p.f3.ma0', title),
      m(`i.f1.blue.ion-ios-arrow-${isOpen() ? 'up' : 'down'}`)
    ]),
    m('div.w-100.pt2.pb3', {
      style: {
        display: isOpen() ? 'block' : 'none'
      }
    }, content)
  ]);
}

function renderPropertiesSection() {
  return [
    m('label', 'Name:'),
    m('input.form-control.mb2', {
      type: 'text',
      oninput: (ev) => Action.form.name(ev.target.value),
      value: Action.form.name(),
    }),
    m('label', 'Room Number:'),
    m('input.form-control.mb2', {
      type: 'text',
      oninput: (ev) => Action.form.roomNumber(ev.target.value),
      value: Action.form.roomNumber(),
    })
  ];
}

function renderMapSection() {
  return [
    m('label', 'Default Map View:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => Action.form.defaultMapView(ev.target.value),
      value: Action.form.defaultMapView(),
    }),
    m('label', { for: 'comment' }, 'GeoJson Data:'),
    m('textarea', {
      resize: 'none',
      rows: '5',
      cols: '40',
      'box-sizing': 'border-box',
      placeholder: "Add GeoJson data here...",
      oninput: ev => Action.form.geojson(ev.target.value),
      value: Action.form.geojson()
    }),
    m('label', 'Map SVG:'),
    m('textarea.form-control.mb2', {
      resize: 'none',
      rows: '5',
      cols: '40',
      'box-sizing': 'border-box',
      placeholder: "Paste Map SVG markup here...",
      oninput: ev => Action.form.svg(ev.target.value),
      value: Action.form.svg()
    })
  ];
}

function renderDiagramSection() {
  return [
    m('label', 'Diagram SVG:'),
    m('textarea.form-control.mb2', {
      resize: 'none',
      rows: '5',
      cols: '40',
      'box-sizing': 'border-box',
      placeholder: "Paste SVG markup here...",
      oninput: ev => {
        Action.form.diagramSvg(ev.target.value);
        if (Action.form.diagramSvgConverted) Action.form.diagramSvgConverted('');
      },
      value: Action.form.diagramSvg()
    })
  ];
}

function renderPortsSection() {
  return m('div.w-100.pt2.pb3', [
    m('div.flex.w-100.mb1', [
      m('div.tc.v-btm.fw2.bw1.ph2', {
        style: { width: '15%' }
      }, [
        m('p.ma0.tc.truncate', 'Name')
      ]),
      m('div.tc.v-btm.fw2.bw1.ph2', {
        style: { width: '15%' }
      }, [
        m('p.ma0.tc.truncate', 'External Position')
      ]),
      m('div.tc.v-btm.fw2.bw1.ph2.w-10', [
        m('p.ma0.tc.truncate', 'Type')
      ]),
      m('div.tc.v-btm.fw2.bw1.ph2',
        {
          style: { width: '15%' }
        }, [
        m('p.ma0.tc.truncate', 'Arrow Direction')
      ]),
      m('div.tc.v-btm.fw2.bw1.ph2',
        {
          style: { width: '15%' }
        }, [
        m('p.ma0.tc.truncate', 'Arrow Connector')
      ]),
      m('div.tc.v-btm.fw2.bw1.ph2.w-20', [
        m('p.ma0.tc.truncate', 'Class')
      ]),
      m('div.tc.v-btm.fw2.bw1.ph2.w-10', [

      ])
    ]),
    Action.portValues.map((port, idx) => {
      if (port.position == 'center') {
        port.type = 'bidirectional';
      }
      return m('div.flex.items-center.mb1', [
        m('div.mr1', {
          style: { width: '15%' }
        }, [
          m('input.form-control', {
            id: 'name-input',
            type: 'text',
            oninput: function (ev) { port.name = ev.target.value; },
            value: port.name,
          })
        ]),
        m('div.mr1', {
          style: { width: '15%' }
        }, [
          m('select', {
            onchange: function (ev) { port.position = ev.target.value; },
            value: port.position
          }, [
            m('option', { value: 'center', disabled: Action.portCenterSelected() ? true : false }, 'Center'),
            m('option', { value: 'left' }, 'Left'),
            m('option', { value: 'right' }, 'Right'),
            m('option', { value: 'top' }, 'Top'),
            m('option', { value: 'bottom' }, 'Bottom')
          ])
        ]),
        m('div.w-10.mr1', [
          m('select', {
            onchange: function (ev) { port.type = ev.target.value; },
            value: port.type,
          }, [
            port.position == 'center' ?
              m('option', { value: 'bidirectional' }, 'Bidirectional')
              :
              [
                m('option', { value: 'input' }, 'Input'),
                m('option', { value: 'output' }, 'Output')

              ]
          ])
        ]),
        m('div.mr1', {
          style: { width: '15%' }
        }, [
          m('select', {
            onchange: function (ev) { port.direction = ev.target.value; },
            value: port.direction,
          }, [
            m('option', { value: 'right' }, 'Right'),
            m('option', { value: 'left' }, 'Left')
          ])
        ]),
        m('div.mr1', {
          style: { width: '15%' }
        }, [
          m('select', {
            onchange: function (ev) { port.connector = ev.target.value; },
            value: port.connector,
          }, [
            m('option', { value: 'head' }, 'Head'),
            m('option', { value: 'tail' }, 'Tail')
          ])
        ]),
        m('div.w-20.mr1', [
          m('select', {
            onchange: function (ev) { serviceTaxonomy.setServiceClass(port, ev.target.value); },
            value: serviceTaxonomy.getServiceClass(port)
          }, [
            (() => {
              let options = [];
              let level = 0;
              measurableModel.measurableClassTree.categories.map(category => {
                options.push(m('option', { value: category.name }, `${'-'.repeat(level)} ${category.name}`));
                if (category.children && Array.isArray(category.children)) {
                  addOptions(category.children, options, level);
                }
              })
              return options;
            })()
          ])
        ]),
        m('div.w-10', [
          m(buttonElement, {
            class: 'w3 fr',
            label: m('i.f4.ion-ios-trash.red'),
            func: function () {
              Action.portValues.splice(idx, 1)
            }
          }),
        ])
      ])
    }),
    m('div.flex.w-100.justify-between', [
      m(buttonElement, {
        class: 'fr blue',
        label: [
          m('i.ion-plus.blue.mr1'),
          'Add Port'
        ],
        func: function () {
          Action.portValues.push(buildNewRoomPort(Action.portValues))
        }
      })
    ]),
  ]);
}

Action.view = function () {
  ensureRoomSectionState();
  Action.portCenterSelected = prop(false);
  Action.portValues.forEach(port => {
    if (port.position == 'center') {
      Action.portCenterSelected(true);
    };
  });

  return m('form', { role: 'form' }, [
    Action.errorView(),
    collapsibleSection({
      index: 0,
      title: 'Properties',
      isOpen: Action.propertiesSectionOpen,
      toggle: () => {
        Action.propertiesSectionOpen(!Action.propertiesSectionOpen());
        m.redraw();
      },
      content: m('div', renderPropertiesSection())
    }),

    collapsibleSection({
      index: 1,
      title: 'Map',
      isOpen: Action.mapSectionOpen,
      toggle: () => {
        Action.mapSectionOpen(!Action.mapSectionOpen());
        m.redraw();
      },
      content: m('div', renderMapSection())
    }),

    collapsibleSection({
      index: 2,
      title: 'Diagram',
      isOpen: Action.diagramSectionOpen,
      toggle: () => {
        Action.diagramSectionOpen(!Action.diagramSectionOpen());
        m.redraw();
      },
      content: m('div', renderDiagramSection())
    }),

    collapsibleSection({
      index: 3,
      title: 'Ports',
      isOpen: Action.portsSectionOpen,
      toggle: () => {
        Action.portsSectionOpen(!Action.portsSectionOpen());
        m.redraw();
      },
      content: m('div', renderPortsSection())
    }),
  ])
};

function addOptions(childrenArray, options, level) {
  level++;
  childrenArray.map(category => {
    options.push(m('option', {value: category.name}, `${'-'.repeat(level)} ${category.name}`));
    if (category.children && Array.isArray(category.children)) {
      addOptions(category.children, options, level);
    }
  })
};

function findFirstServiceClass(categories) {
  for (let idx = 0; idx < (categories || []).length; idx++) {
    let category = categories[idx];
    if (!category) continue;
    if (category.name && category.name !== 'Overview') return category.name;
    let childClass = findFirstServiceClass(category.children || []);
    if (childClass) return childClass;
  }
  return '';
}

function getDefaultServiceClass() {
  return findFirstServiceClass((measurableModel.measurableClassTree || {}).categories || []);
}

function portListValues(ports) {
  return Array.isArray(ports) ? ports : Object.values(ports || {});
}

function nextRoomPortId(ports) {
  var ids = portListValues(ports)
    .map(function (port) {
      return Number(port && port.id);
    })
    .filter(Number.isFinite);
  return ids.length > 0 ? Math.max(...ids) + 1 : 1;
}

function normalizeRoomPortType(position, type) {
  if (position === 'center') return 'bidirectional';
  return type === 'input' || type === 'output' ? type : DEFAULT_ROOM_PORT_TYPE;
}

function normalizeRoomPortId(id, fallbackId) {
  var numericId = Number(id);
  if (Number.isFinite(numericId) && numericId > 0) return numericId;
  return fallbackId;
}

function buildRoomPortPayload(portData, fallbackId) {
  var port = Object.assign({}, portData || {});
  var position = port.position || DEFAULT_ROOM_PORT_POSITION;
  var serviceClass = serviceTaxonomy.getServiceClass(port) || getDefaultServiceClass();

  port.name = typeof port.name === 'string' ? port.name : '';
  port.id = normalizeRoomPortId(port.id, fallbackId || 1);
  port.position = position;
  port.type = normalizeRoomPortType(position, port.type);
  port.direction = port.direction || DEFAULT_ROOM_PORT_DIRECTION;
  port.connector = port.connector || DEFAULT_ROOM_PORT_CONNECTOR;

  if (serviceClass) {
    serviceTaxonomy.setServiceClass(port, serviceClass);
  }

  return port;
}

function buildNewRoomPort(existingPorts) {
  return buildRoomPortPayload({
    name: '',
    id: nextRoomPortId(existingPorts)
  });
}

function normalizeRoomPorts(ports) {
  return portListValues(ports).map(function (port, index) {
    return buildRoomPortPayload(port, index + 1);
  });
}

Action._private = {
  buildNewRoomPort,
  buildRoomPortPayload,
  findFirstServiceClass,
  getDefaultServiceClass,
  nextRoomPortId,
  normalizeRoomPortType,
  normalizeRoomPorts
};



module.exports = Action;
